import axios from 'axios';

import download from '../utils/download';
import {
  getExportDatasetUrlParams,
  getIncludeMetadata,
  getIncludeDataset,
  getExportDatasetMime,
  getFileFormat,
} from '../selectors/exportDialog';
import { getExportDatasetSaveAs } from '../selectors/exportSaveAs';
import { getCompare, getCrimeType } from '../selectors/options';
import { isCensusView } from '../selectors/router';
import { ExportFileFormat } from '../constants';

export const types = {
  SET_EXPORT_INCLUDE_DATASET: 'SET_EXPORT_INCLUDE_DATASET',
  SET_EXPORT_FILE_FORMAT: 'SET_EXPORT_FILE_FORMAT',
  SET_EXPORT_SOURCE: 'SET_EXPORT_SOURCE',
  SET_EXPORT_TIME_SOURCE: 'SET_EXPORT_TIME_SOURCE',
  SET_EXPORT_INCLUDE_METADATA: 'SET_EXPORT_INCLUDE_METADATA',
  OPEN_EXPORT_DIALOG: 'OPEN_EXPORT_DIALOG',
  CLOSE_EXPORT_DIALOG: 'CLOSE_EXPORT_DIALOG',
  EXPORT_DOWNLOAD: 'EXPORT_DOWNLOAD',
  SET_AGREED_TO_TERMS: 'SET_AGREED_TO_TERMS',
};

export const setIncludeDataset = payload => ({
  type: types.SET_EXPORT_INCLUDE_DATASET,
  payload,
});

export const setFileFormat = payload => ({
  type: types.SET_EXPORT_FILE_FORMAT,
  payload,
});

export const setExportSource = payload => ({
  type: types.SET_EXPORT_SOURCE,
  payload,
});

export const setTimeSource = payload => ({
  type: types.SET_EXPORT_TIME_SOURCE,
  payload,
});

export const setIncludeMetadata = payload => ({
  type: types.SET_EXPORT_INCLUDE_METADATA,
  payload,
});

export const setAgreedToTerms = payload => ({
  type: types.SET_AGREED_TO_TERMS,
  payload,
});

export const openExportDialog = payload => ({
  type: types.OPEN_EXPORT_DIALOG,
  payload,
});

export const closeExportDialog = payload => ({
  type: types.CLOSE_EXPORT_DIALOG,
  payload,
});

export const handleDownloads = cancelSource => (dispatch, getState) => {
  const state = getState();

  const exportAPI = isCensusView(state) ? '/exportCensus' : '/export';
  const compare = getCompare(state) !== 'none';

  const downloadSettings = {
    cancelToken: cancelSource.token,
    responseType: 'arraybuffer',
  };

  const saveData = (saveAs, mime) => response => {
    download(new Blob([response.data]), saveAs, mime);
  };

  const includeMeta = getIncludeMetadata(state);
  const includeData = getIncludeDataset(state);
  const datasetFormat = getFileFormat(state);
  const fileName = getExportDatasetSaveAs(state);
  const crimeType = getCrimeType(state);

  dispatch({
    type: types.EXPORT_DOWNLOAD,

    payload: axios
      .post(
        exportAPI,
        {
          includeMeta,
          includeData,
          compare,
          crimeType,
          ...getExportDatasetUrlParams(state),
        },
        downloadSettings,
      )
      .then(
        includeMeta && includeData
          ? saveData(`${fileName}.zip`, 'application/zip')
          : includeMeta
            ? saveData('metadata.pdf', 'application/pdf')
            : saveData(
                fileName +
                  (datasetFormat === ExportFileFormat.CSV ? '.csv' : '.xlsx'),
                getExportDatasetMime(state),
              ),
      ),
  });
};

export const cancelDialog = cancelSource => (dispatch, getState) => {
  if (cancelSource) {
    cancelSource.cancel();
    cancelSource = null;
  }
  dispatch(closeExportDialog());
};



// WEBPACK FOOTER //
// ./src/actions/exportDialog.js